module.exports = __webpack_public_path__ + "static/fonts/notokr-medium.6a273c1.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/concierge/font/notosanskr/notokr-medium.woff2
// module id = MSrY
// module chunks = 0